module.exports = __webpack_public_path__ + "assets/img/20961c64771f657b63ef11471862074a.svg";